import { render, staticRenderFns } from "./FileUploadDropzone.vue?vue&type=template&id=13126e16"
import script from "./FileUploadDropzone.vue?vue&type=script&lang=js"
export * from "./FileUploadDropzone.vue?vue&type=script&lang=js"
import style0 from "./FileUploadDropzone.vue?vue&type=style&index=0&id=13126e16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports